/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Conlicitacast from 'assets/images/background_modal_robo.svg';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { Container } from './styles';

interface ModalRoboProps {
  show?: boolean;
  onClose?: () => void;
}

const ModalRobo = ({ show = false, onClose }: ModalRoboProps) => {
  const [internalShow, setInternalShow] = useState(false);

  useEffect(() => {
    if (!hasCookie('modalRobo')) {
      setInternalShow(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('modalRobo', true);
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal show={shouldShow} className="p-0" size="lg" onHide={handleClose}>
      <Container>
        <div className="position-relative text-center bg-white">
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">&times;</span>
          </button>
          <a href="/robo_lance" rel="noreferrer">
            <img className="card-img-top" src={Conlicitacast} alt="chat" />
          </a>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalRobo;
